import { CommonUtilsService } from 'util/services';
import { Action } from 'util/domain';

export enum ToastMessageType {
	simple = 'simple',
	action = 'action',
	progress = 'progress'
}

export enum ToastProgressMode {
	determinate = 'determinate',
	indeterminate = 'indeterminate'
}

export interface SimpleToastMessage {
	type: typeof ToastMessageType.simple,
	message: string;
	hideDelay?: number;
}

export interface ToastAction {
	fn: () => void;
	tooltip: string;
	icon: string;
}

export interface ActionToastMessage {
	type: typeof ToastMessageType.action;
	message: string;
	hideDelay?: number;
	action: ToastAction;
}

export interface DeterminateProgressToastMessage {
	type: typeof ToastMessageType.progress;
	message: string;
	action?: ToastAction;
	readonly progress?: number;
	mode: typeof ToastProgressMode.determinate;
}

export interface IndeterminateProgressToastMessage {
	type: typeof ToastMessageType.progress;
	message: string;
	action?: ToastAction;
	mode: typeof ToastProgressMode.indeterminate;
}

export type ProgressToastMessage = DeterminateProgressToastMessage | IndeterminateProgressToastMessage;

export interface ProgressMessageOptions {
	progressFn?: () => number;
	cancelFn?: () => void;
	message: string | (() => string);
}

export type ToastMessage =
	| SimpleToastMessage
	| ActionToastMessage
	| ProgressToastMessage;

export interface OnQueueEmptyCallback {
	(): void;
}


// WEBPACK FOOTER //
// ./src/sharebase/domain/toast-message.ts